import { Model } from '../../shared-features/models/model';

export class RentedTrucksStatus extends Model {
  totalTrucks: number = 0;
  totalShipments: number = 0;
  totalCost: number = 0;
  totalPrice: number = 0;
  totalMargin: number = 0;
}
